import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      // No session_id found, redirect to login
      window.location.href = window.location.pathname + '#/login';
      return;
    }

    const sessionId = match[1];

    loginWithGoogle(sessionId)
      .then(() => {
        // Force redirect to dashboard via HashRouter path
        window.location.href = window.location.pathname + '#/';
      })
      .catch((err) => {
        console.error('Google auth failed:', err);
        window.location.href = window.location.pathname + '#/login';
      });
  }, [loginWithGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-[#FF8C42] border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-500 text-sm">Authenticating...</p>
      </div>
    </div>
  );
}
